import { TARGETS } from '../../../pages/vehicle/[vehicleId]'
import { Button } from '../../../components/button'
import Modal from '../../../components/modal'

export default function CannotBuyYourVehicle({ onClose, target }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn alignCenter'>
        <h3>
          {target === TARGETS.Offer ? 'Offering' : target === TARGETS.BuyNow ? 'Buying' : 'Bidding'}
        </h3>
        <p>
          {target === TARGETS.Offer
            ? 'You can not make an offer on your own vehicles'
            : target === TARGETS.BuyNow
            ? 'You can not buy your own vehicles'
            : 'You can not bid on your own vehicles'}
        </p>
        <Button onClick={onClose}>Close</Button>
      </div>

      <style jsx>{`
        .wrapper {
          max-width: 100vw;
          width: 43.6rem;
          padding: 2.8rem 2rem 4.8rem;
          background: #fff;
          border-radius: 1rem;

          h3 {
            font-size: 3.6rem;
          }

          p {
            margin: 2.2rem 0;
            line-height: 2rem;
            font-size: 1.6rem;
          }
        }
      `}</style>
    </Modal>
  )
}
